import { useEffect, useState } from 'react';
import { api } from './api.js';
import { Notice } from './components.js';
import { rememberReturnTab, sessionStore, type ReturnTab } from './entry.js';
import { getLocale, t } from './i18n.js';

/**
 * Whether a sensitive action needs a fresh sign-in first: an account without a second factor,
 * signed in more than a few minutes ago (server rule: auth.confirmationRequired).
 */
export function useConfirmationRequired() {
  const [required, setRequired] = useState(false);
  useEffect(() => {
    api<{ required: boolean }>('/auth/confirmation')
      .then((r) => setRequired(r.required))
      .catch(() => {
        // The action itself is refused by the server if a confirmation is needed.
      });
  }, []);
  return required;
}

export function ConfirmIdentity({ returnTo }: { returnTo: ReturnTab }) {
  return (
    <Notice>
      {t(
        'Pour cette action, confirmez votre identité en vous reconnectant. Avec la double authentification, vous n’aurez plus à le faire.',
      )}{' '}
      <a
        className="secondary small"
        href={`/v1/auth/oidc?locale=${getLocale()}`}
        onClick={() => rememberReturnTab(returnTo, sessionStore())}
      >
        {t('Me reconnecter')}
      </a>
    </Notice>
  );
}
